import {apiSlices, store} from "../store"
import {setSelectedBranchId} from "../app/appSlice"

const ACCOUNT_SCOPED_STORAGE_KEYS = [
    "orders_filters_v1",
    "reviews_filters_v1",
    "delivery_center_scope_v1"
]

export const resetSessionData = () => {
    store.dispatch(setSelectedBranchId(undefined))
    apiSlices.forEach((api) => {
        store.dispatch(api.util.resetApiState())
    })

    if (typeof window === "undefined") return

    ACCOUNT_SCOPED_STORAGE_KEYS.forEach((key) => {
        window.localStorage.removeItem(key)
    })
}
